import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const UnauthorizedMedia = lazyWithSuspense(async () => import('./UnauthorizedMediaScreen'), {
  loadingState: <LoadingState />,
});
